function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -996.362)",
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 5,
  x: 14.5,
  y: 1024.362,
  rx: 1,
  ry: 1,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.946 1002.362c7.914-1.825 15.963-1.625 24.108 0 .485.097.892.398.892.893v4.464c0 .495-.408.994-.892.893-7.614-1.584-15.575-1.864-24.108 0-.483.106-.892-.398-.892-.893v-4.464c0-.495.41-.782.892-.893z",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 1029.362h3.553v23H15.75zM34.697 1029.362h3.553v23h-3.553z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27 1024.362v-17M31 1024.362l1-16.8M35 1024.362l2-16M23 1024.362l-1-16.8M19 1024.362l-2-16M19 1034.362h16"
}));

var SvgChair = function SvgChair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chair.34787c8a.svg";
export { ForwardRef as ReactComponent };